// src/pages/Welcome.jsx
import React from "react";
import { useTranslation } from "react-i18next";

import welcomeIcon from "../assets/icons/welcome.svg";
import settingIcon from "../assets/icons/settings.svg";
import winIcon from "../assets/icons/win.svg";
import appleIcon from "../assets/icons/Apple.svg";

import CopyButton from "../components/CopyButton";
import CaretLi from "../components/CaretLi";
import NextSectionCard from "../components/NextSectionCard";
import { timeSince } from "../utils/timeSince";

const Welcome = () => {
  const { t, i18n } = useTranslation();

  const lastUpdated = "2025-12-05";
  const lang = i18n.language;

  const buildCopyText = (t) => {
    return `
${t("welcome.title")}

${t("welcome.intro.p1")}
${t("welcome.intro.p2")}
${t("welcome.intro.p3")}

${t("welcome.techOverview.title")}
- ${t("welcome.techOverview.architecture.item1")}
- ${t("welcome.techOverview.architecture.item2")}
- ${t("welcome.techOverview.architecture.item3")}
- ${t("welcome.techOverview.architecture.item4")}
- ${t("welcome.techOverview.architecture.item5")}
- ${t("welcome.techOverview.architecture.item6")}

${t("welcome.features.title")}
- ${t("welcome.features.item1")}
- ${t("welcome.features.item2")}
- ${t("welcome.features.item3")}
- ${t("welcome.features.item4")}
- ${t("welcome.features.item5")}
- ${t("welcome.features.item6")}

${t("welcome.download.description")}
${t("welcome.download.description2")}
`.trim();
  };

  const handleDownloadWindows = () => {
    const url = process.env.REACT_APP_WINDOW_DOWNLOAD_URL;
    window.location.href = url;
  };

  return (
    <div className="text-[#0F172A] dark:text-[#F1F5F9]">
      <div
        className="
          desktop:px-4
          max-w-3xl
        "
      >
        {/* Header + copy */}
        <div className="relative flex items-center justify-between gap-3 desktop:flex-row-reverse tabletpro:flex-row-reverse tabletair:flex-row-reverse
        tabletmini:flex-row-reverse mobile:flex-col mobile:items-stretch mini_mobile:flex-col mini_mobile:items-stretch">
          {/* Copy button */}
          <div className="mobile:flex mobile:justify-end mini_mobile:flex mini_mobile:justify-end mobile:order-1">
            <CopyButton text={buildCopyText(t)} />
          </div>

          {/* Welcome text */}
          <div className="flex items-center gap-3 mobile:order-2">
            <img
              src={welcomeIcon}
              alt="welcome"
              className="w-9 h-9 mobile:w-6 mobile:h-6"
            />
            <h1 className="text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[28px] mobile:text-[28px] mini_mobile:text-[24px] font-semibold">
              {t("sidebar.welcome")}
            </h1>
          </div>
        </div>


        {/* Nội dung chính */}
        <div className="mt-4 relative space-y-6">
          {/* Đoạn giới thiệu */}
          <section className="space-y-3 text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
            <p>{t("welcome.intro.p1")}</p>
            <p>{t("welcome.intro.p2")}</p>
            <p>{t("welcome.intro.p3")}</p>
          </section>

          {/* Tổng quan kỹ thuật */}

          <section className="space-y-3">
            <h2 className="text-[#020617] dark:text-[#F8FAFC] flex items-center gap-2 text-[24px] tabletpro:text-[22px] mobile:text-[22px] font-semibold">
              <img src={settingIcon} alt="settings" className="w-6 h-6" />
              <p>{t("welcome.techOverview.title")}</p>
            </h2>
          </section>

          <section className="space-y-3">
            <ul className="space-y-1.5 text-[16px]">
              <h3 className="text-[#020617] dark:text-[#F8FAFC] text-[18px] font-semibold">
                {t("welcome.techOverview.architecture.title")}
              </h3>
              <p className="font-normal pb-1">{t("welcome.techOverview.architecture.item1")}</p>
              <CaretLi>{t("welcome.techOverview.architecture.item2")}</CaretLi>
              <CaretLi>{t("welcome.techOverview.architecture.item3")}</CaretLi>
              <CaretLi>{t("welcome.techOverview.architecture.item4")}</CaretLi>
              <CaretLi>{t("welcome.techOverview.architecture.item5")}</CaretLi>
              <CaretLi>{t("welcome.techOverview.architecture.item6")}</CaretLi>
            </ul>
          </section>

          {/* Các tính năng chính */}
          <section className="space-y-3">
            <h3 className="text-[#020617] dark:text-[#F8FAFC] text-[18px] font-semibold">
              {t("welcome.features.title")}
            </h3>
            <ul className="space-y-1.5 text-[16px]">
              <CaretLi>{t("welcome.features.item1")}</CaretLi>
              <CaretLi>{t("welcome.features.item2")}</CaretLi>
              <CaretLi>{t("welcome.features.item3")}</CaretLi>
              <CaretLi>{t("welcome.features.item4")}</CaretLi>
              <CaretLi>{t("welcome.features.item5")}</CaretLi>
              <CaretLi>{t("welcome.features.item6")}</CaretLi>
            </ul>
          </section>

          {/* Download buttons */}
          <section className="space-y-5">
            <p className="text-[16px] font-normal">
              {t("welcome.download.description")}
            </p>

            <p className="text-[16px] font-normal">
              {t("welcome.download.description2")}
            </p>

            <div className="flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleDownloadWindows}
                className="
    flex items-center rounded-full border px-4 py-2 transition-all
    text-[16px] tabletpro:text-[12px] tabletair:text-[14px] tabletmini:text-[14px] mobile:text-[14px]
    hover:shadow-[0_0_10px_2px_rgba(0,166,255,0.6)]
    font-light bg-[#036ae5] hover:bg-[#0360d0] text-[#F8FAFC] border-[#024ba3] hover:border-[#8BBAF3] mobile:w-full mobile:items-center mobile:justify-center
  "
              >
                GoPaperless Agent – Windows
                <img src={winIcon} alt="windows" className="w-7 h-7 pl-2" />
              </button>

              <button
                type="button"
                className="
                  flex justify-center items-center rounded-full border px-4 py-2 transition-all
                  text-[16px] tabletpro:text-[12px] tabletair:text-[14px] tabletmini:text-[14px] mobile:text-[14px]
                  hover:shadow-[0_0_10px_2px_rgba(0,166,255,0.6)]
                  font-light bg-[#036ae5] hover:bg-[#0360d0] text-[#F8FAFC] border-[#024ba3] hover:border-[#8BBAF3] mobile:w-full mobile:items-center mobile:justify-center
                "
              >
                GoPaperless Agent – macOS
                <img src={appleIcon} alt="macos" className="w-7 h-7 pl-2 pb-1" />
              </button>
            </div>
          </section>

          {/* Next section card */}
          <section>
            <NextSectionCard
              label={t("sidebar.version")}
              to="/version"
            />
          </section>

          {/* Last updated */}
          <section>
            <span className="text-[14px] text-[#64748B]">
              {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
            </span>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Welcome;
